module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/sold-property-cluster-pin-301d31df33034dfe18a83b70a0531060.svg";